import React, { useEffect, useState } from "react";
import "./internalUsers.scss";
import avatarPlaceholder from "../../assets/placeholder/avatar_placeholder.png";
import CardMenu from "../../shared/components/CourseComponents/CardMenu";
import AppHeader from "../../shared/components/AppHeader";
import DeleteAlert from "../../shared/components/DeleteAlert";
import TableComponent from "../../shared/components/TableComponent";
import InternalUserForm from "./InternalUserForm";
import InternalUserService from "../../services/InternalUserService/internalUser.service";
import { InternalUserModel } from "../../models/InternalUserModel/internalUser.model";
import { PaginationModel } from "../../models/PaginationModel/pagination.model";
import EmptyState from "../../shared/components/EmptyState";
import Filters from "../../shared/components/Filters";
import { Divider } from "antd";
import Checkbox from "antd/lib/checkbox/Checkbox";
import CheckboxComponent from "../../shared/components/CheckboxComponent";

const InternalUsers = () => {
  const [formVisible, setFormVisible] = useState<boolean>(false);
  const [deleteVisible, setDeleteVisible] = useState<boolean>(false);
  const [currentUser, setCurrentUser] = useState<any>(null);
  const [internalUsers, setInternalUsers] = useState<any>([]);
  const [paginationMeta, setPaginationMeta] = useState<any>();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [showFilter, setFilterVisibility] = useState(false);
  const [roleFilters, setRoleFilters] = useState([
    {
      value: "Admin",
      checked: false,
    },
    {
      value: "Product manager",
      checked: false,
    },
  ]);
  const [statusFilters, setStatusFilters] = useState([
    {
      value: "Active",
      checked: false,
    },
    {
      value: "Inactive",
      checked: false,
    },
  ]);
  useEffect(() => {
    fetchInternalUsers(1);
  }, []);

  useEffect(() => {
    setCurrentUser(formVisible && currentUser ? currentUser : null);
  }, [formVisible]);

  const fetchInternalUsers = (pageNumber: number, searchString?: string) => {
    let queryParam = `?per_page=15&page=${pageNumber}&search=${
      searchString || ""
    }`;

    InternalUserService.getInternalUsersList(
      queryParam,
      (internalUsers: InternalUserModel, pagination: PaginationModel) => {
        setInternalUsers(internalUsers);
        setPaginationMeta(pagination);
        setCurrentUser(null)
      },
      () => {},
      () => {}
    ).then();
  };

  const handleDelete = () => {
    InternalUserService.deleteInternalUser(
      currentUser.id,
      () => {
        fetchInternalUsers(currentPage);
        setDeleteVisible(false);
        setCurrentUser(null)
      },
      () => {},
      () => {}
    ).then();
  };

  const handleSearch = (value: string) => {
    fetchInternalUsers(currentPage, value);
  };

  const columns = [
    {
      title: "User ID",
      dataIndex: "userId",
      key: "userId",
      sorter: (a: any, b: any) => (a.userId > b.userId ? 1 : -1),
    },
    {
      title: "Name",
      dataIndex: "fullName",
      key: "fullName",
      render: (name: string, record: any) => (
        <>
          <img
            src={record.displayPictureUrl || avatarPlaceholder}
            alt=""
            className="table-image"
          />{" "}
          {name}
        </>
      ),
      sorter: (a: any, b: any) => (a.fullName > b.fullName ? 1 : -1),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      render: (role: any) => (
        <span style={{ textTransform: "capitalize" }}>{role.label}</span>
      ),
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      render: (text: boolean) => (
        <>
          <span
            className={`status__indicator ${text ? "active" : "inactive"}`}
          />
          {text ? "Active" : "Inactive"}
        </>
      ),
      sorter: (a: any, b: any) => a.isActive - b.isActive,
    },
    {
      title: "",
      dataIndex: "",
      key: "action",
      render: (text: string, record: any) => (
        <div
          onClick={(event) => {
            event.stopPropagation();
            setCurrentUser(record);
          }}
        >
          <CardMenu
            menuText="User"
            handleEdit={setFormVisible}
            handleDelete={setDeleteVisible}
          />
        </div>
      ),
    },
  ];

  const dataSource = internalUsers.map((internalUser: any) => ({
    key: internalUser.id,
    id: internalUser.id,
    userId: internalUser.id,
    firstName: internalUser.firstName,
    lastName: internalUser.lastName,
    fullName: internalUser.fullName,
    email: internalUser.email,
    phoneNumber: internalUser.phoneNumber,
    roleName: internalUser.roleName,
    role: internalUser.role,
    isActive: internalUser.isActive,
    password: internalUser.password,
    displayPictureUrl: internalUser.displayPictureUrl,
  }));

  return (
    <div className="page-view">
      <AppHeader
        headerText="Internal Users"
        handleSearch={handleSearch}
        handleHeaderAction={() => setFormVisible(true)}
        buttonText="User"
        showBreadCrumb={false}
        showFilter={true}
        // handleFilter={() => setFilterVisibility(true)}
      />
      {currentUser ? (
        <InternalUserForm
          title="Edit user"
          visible={formVisible}
          setVisible={setFormVisible}
          data={currentUser}
          refreshList={fetchInternalUsers}
          currentPageNumber={currentPage}
        />
      ) : (
        <InternalUserForm
          title="Create new user"
          visible={formVisible}
          setVisible={setFormVisible}
          refreshList={fetchInternalUsers}
          currentPageNumber={currentPage}
        />
      )}
      <DeleteAlert
        visible={deleteVisible}
        setVisible={setDeleteVisible}
        deleteText={"user"}
        contentTitle={currentUser?.fullName}
        logo={currentUser?.displayPictureUrl || avatarPlaceholder}
        detail={currentUser?.role?.name}
        handleDelete={handleDelete}
      />
      {internalUsers.length !== 0 ? (
        <TableComponent
          dataSource={dataSource}
          columns={columns}
          pagination={paginationMeta}
          fetchList={fetchInternalUsers}
          setCurrentPage={setCurrentPage}
        />
      ) : (
        <EmptyState text={"No internal users found."} />
      )}
      <Filters
        expand={showFilter}
        handleApply={() => {}}
        handleReset={() => {}}
        closeHandler={() => setFilterVisibility(false)}
      >
        <CheckboxComponent
          group
          title={"Role"}
          data={roleFilters}
          onChange={(index) => {
            let data = roleFilters;
            data[index].checked = !roleFilters[index].checked;
            setRoleFilters([...data]);
          }}
        />
        <Divider />
        <CheckboxComponent
          group
          title={"Status"}
          data={statusFilters}
          onChange={(index) => {
            let data = statusFilters;
            data[index].checked = !statusFilters[index].checked;
            setStatusFilters([...data]);
          }}
        />
      </Filters>
    </div>
  );
};

export default InternalUsers;
